import Vue from "vue";
import Vant from "vant";
import { Lazyload } from "vant";
import "vant/lib/index.less";
Vue.use(Vant);
Vue.use(Lazyload);

// import {
//   Button,
//   NavBar,
//   NumberKeyboard,
//   Icon,
//   Image as VanImage,
//   Popup,
//   Dialog,
//   Toast,
//   PullRefresh,
//   List,
//   Stepper,
//   Picker,
//   Divider,
//   Lazyload,
//   Progress,
//   Skeleton,
//   Sticky,
//   Swipe,
//   SwipeItem,
//   Tab,
//   Tabs,
//   DropdownMenu,
//   DropdownItem,
//   Search,
//   Cell,
//   CellGroup,
//   Uploader,
//   GoodsAction,
//   GoodsActionIcon,
//   GoodsActionButton
// } from "vant";

// const components = [
//   Button,
//   NavBar,
//   NumberKeyboard,
//   Icon,
//   VanImage,
//   Popup,
//   Dialog,
//   Toast,
//   PullRefresh,
//   List,
//   Stepper,
//   Picker,
//   Divider,
//   Lazyload,
//   Progress,
//   Skeleton,
//   Sticky,
//   Swipe,
//   SwipeItem,
//   Tab,
//   Tabs,
//   DropdownMenu,
//   DropdownItem,
//   Search,
//   Cell,
//   CellGroup,
//   Uploader,
//   GoodsAction,
//   GoodsActionIcon,
//   GoodsActionButton
// ];
// components.forEach(component => Vue.use(component));
